// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__6RCAE","actionsCol":"EnrolledClinics_actionsCol__jTjoN"};